export default __webpack_public_path__ + "static/media/07.3f970e15.jpg";